export default __webpack_public_path__ + "static/media/Want a Taste of this Chain.e551a085.png";